import React, { useState, useEffect } from "react";
//@ts-ignore
import { LanguageContext } from "../../../../context/LanguageContext.jsx";
//@ts-ignore
import { dataList } from "../../../Admin/AdmMain";
import Page from "../../../Atomic/template/PageTable";
import CommonControl from "../../../Atomic/organism/CommonControl";
import { useNavigate } from "react-router-dom";
//@ts-ignore
import axios from "../../../../lib/axios";
//@ts-ignore
import { useAuth } from "../../../../context/LoginContext.jsx";
//@ts-ignore
import TableAtom from "../../../Atomic/organism/AtomTable";
import { filterData, inputChnage, translate } from "../../../Atomic/exFunc";
import Form from "../../../Atomic/organism/FormAtom";
export default function Table() {
  //@ts-ignore
  const { language } = React.useContext(LanguageContext);
  const navi = useNavigate();
  const [rawData, setRawData] = useState<any>([]);
  const { user } = useAuth();
  const inputRef = React.createRef<HTMLInputElement>();
  const [keyword, setKeyword] = useState("");
  const [data, setData] = useState<any>([]);
  // Function defines
  //===============================================================

  function move(e: any) {
    const i = e.instance.store.focus.rowIndex;
    if (i === undefined) {
      return;
    }
    const idx = e.instance.store.data.rawData[i].idx;

    if (e.columnName === "sms_cnt" && e.targetType != "columnHeader") {
      navi(`/Adm/bas-table/edit`, {
        state: {
          idx: idx,
        },
      });
    }
  }

  function submitFun(e: any) {
    e.preventDefault();
    filterData(rawData, keyword, setData);
  }

  // Data define
  //===============================================================

  const columns: any = [
    {
      header: language === "KOR" ? "번호" : "Num",
      name: "rowKey" + 1,
      width: 70,
      align: "center",
      formatter: (name: any) => name.row.rowKey + 1,
    },

    {
      header: translate(
        "1차 분류명 (Korean)",
        "1st Classification Name (Korean)",
        language
      ),
      name: "nm_kor",
      align: "center",
    },
    {
      header: translate(
        "1차 분류명 (English)",
        "1st Classification Name (English)",
        language
      ),
      name: "nm_eng",
      align: "center",
    },
    {
      header: translate(
        "2차 분류수",
        "2nd Classification count",
        language
      ),
      name: "cnt",
      align: "center",
    },

    {
      header: translate("수정", "Edit", language),
      name: "sms_cnt",
      align: "center",
      formatter: (name: any) =>
        `<div class="link cursor" >${translate(
          "수정",
          "Edit",
          language
        )}</div>`,
      width: 70,
    },
  ];

  const buttonData = [
    {
      labelKR: "전체목록",
      labelEN: "View All",
      classN: "white",
      clickFun: () => {
        setKeyword("");
      },
      position: "left",
      icon: false,
      iconClass: "",
    },
    {
      labelKR: "등록",
      labelEN: "Add new",
      classN: "purple",
      icon: true,
      clickFun: () => {
        navi("/Adm/bas-table/new");
      },
      position: "right",
    },
  ];

  const formData = {
    lan: language,
    inputId: "keyword",
    type: "text",
    placeKR: "검색어를 입력하세요",
    placeEN: "Please enter a search term",
    submitHandler: submitFun,
    filter: (e: any) => inputChnage(e, rawData, setData, setKeyword),
    myref: inputRef,
    option: undefined, // Make option undefined
    value: keyword,
  };

  // useEffect define
  //===============================================================

  useEffect(() => {
    axios
      .get(`/web/admin/basic/list?type=${user.type}`)
      .then((res: any) => {
        setRawData(res.data);
      });
  }, [user]);
  useEffect(() => {
    if (rawData && keyword === "") {
      setData(rawData);
    } else if (rawData && keyword !== "") {
      filterData(rawData, keyword, setData);
    }
  }, [rawData, keyword]);

  // logs define
  //===============================================================
  // console.log("rawData", rawData);
  return (
    <>
      <Page
        language={language}
        dataList={dataList}
        title={`${
          language === "KOR" ? "기초코드 관리" : "Basic code management"
        }`}
        menu="/Adm/bas-table"
      >
        <Form formData={formData} inputRef={inputRef} />
        <TableAtom data={data} columns={columns} move={move} />
        <CommonControl buttonData={buttonData} language={language} />
      </Page>
    </>
  );
}
